module.exports = __webpack_public_path__ + "img/AmSee.c49de892.svg";